import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { IconButton, Tooltip, SvgIcon, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { usePopover } from "@hooks/shared/use-popover";
import { ToolboxPopover } from "./toolbox-popover";
import useAppStore from "@stores/client/useAppStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToolbox } from "@fortawesome/pro-light-svg-icons";

export const ToolboxButton = () => {
  const popover = usePopover();
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const theme = useTheme();

  const { fetchItems } = useAppStore();

  const handleClick = () => {
    const fetchApps = async () => {
      try {
        await fetchItems();
      } catch (error) {
        console.error("Error fetching apps:", error);
      }
    };
    fetchApps();
    popover.handleOpen();
  };

  const isActive = pathname.startsWith("/apps") || popover.open;

  return (
    <>
      <Tooltip title={t("common.toolbox")}>
        <IconButton
          onClick={handleClick}
          ref={popover.anchorRef}
          data-testid="toolbox-button"
          sx={{
            backgroundColor: isActive ? alpha(theme.palette.common.white, 0.1) : "transparent",
            color: isActive ? theme.palette.primary.contrastText : theme.palette.common.white,
            fontWeight: isActive ? 700 : undefined,
          }}
        >
          <SvgIcon>
            <FontAwesomeIcon icon={faToolbox} color="white" />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <ToolboxPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
